<template>
  <div class="ctotal bgps flex">
    <div
      v-for="(i, j) in titlearr"
      :key="j"
      class="f1 flex ac"
      @click="tabclick(j)"
      :style="`color:${ i.select == 1 ? 'white' : ''}`"
      style="text-indent: 0.5rem;"
    >{{ i.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titlearr: {
      default: [
        { label: "项目概况", select: 1 },
        { label: "参建单位", select: 0 },
        { label: "施工管理人员", select: 0 }
      ]
    }
  },
  data() {
    return {};
  },
  methods: {
    tabclick(e) {
      this.$emit("tabnum1", e);
      this.$emit("tabnum2", e);
      for (let i in this.titlearr) {
        if (e == i) {
          this.titlearr[i].select = 1;
        } else {
          this.titlearr[i].select = 0;
        }
      }
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.ctotal {
  width: 100%;
  padding-left: 1.6vw;
  height: 2.5rem;
  line-height: 2.5rem;
  font-family: AlibabaPuHuiTi_2_75_SemiBold;
  font-size: 15px;
  color: #d1d6df;
  margin-left: 2%;
  margin-top: 2%;
  // background: linear-gradient(270deg, #ACDDFF 0%, #FFFFFF 100%);
  background: url("../../assets/image/二级标题-背景.png") no-repeat;
}
</style>
